import { useEffect } from 'react';

import { CombinedGraphQLErrors } from '@apollo/client/errors';

import { BUYERS_SEARCH_PARAMS_SCOPE } from '@modules/_shared/components/buyer-lead/buyerLeadUtils';
import { useScopedSearchParams } from '@modules/_shared/utils/navigation';

const isValidationError = (error: unknown) =>
  CombinedGraphQLErrors.is(error) &&
  error.errors.some(
    graphQLError => graphQLError.extensions?.code === 'validation-failed',
  );

export const useDropRejectedBuyersWhere = (error: unknown): boolean => {
  const [buyersSearchParams, setBuyersSearchParams] = useScopedSearchParams(
    BUYERS_SEARCH_PARAMS_SCOPE,
  );
  const dropping = buyersSearchParams.has('where') && isValidationError(error);

  useEffect(() => {
    if (dropping) {
      setBuyersSearchParams(
        previous => {
          const next = new URLSearchParams(previous);
          next.delete('where');
          return next;
        },
        { replace: true },
      );
    }
  }, [dropping, setBuyersSearchParams]);

  return dropping;
};
